<div class="feedback-panel" [class.feedback-panel--open]="isOpen()">
  <div class="feedback-panel__overlay" (click)="onClose()"></div>

  <div class="feedback-panel__content">
    @if (showSubmitSuccess && !showScreenshotEditor) {
      <div class="feedback-panel__success">
        <div class="feedback-panel__success-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <h3 class="feedback-panel__success-title">Feedback enviado!</h3>
        <p class="feedback-panel__success-desc">Obrigado por nos ajudar a melhorar a plataforma.</p>
        <div class="feedback-panel__success-actions">
          <button type="button" class="feedback-panel__btn-cancel" (click)="onClose()">
            Fechar
          </button>
        </div>
      </div>
    } @else if (showScreenshotEditor && activeScreenshotBlob) {
      <app-feedback-screenshot-editor
        [screenshotBlob]="activeScreenshotBlob"
        (confirmed)="onScreenshotConfirmed($event)"
        (cancelled)="onScreenshotCancelled()" />
    } @else {
      <div class="feedback-panel__header">
        <div class="feedback-panel__header-left">
          <div class="feedback-panel__header-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
              width="16"
              height="16">
              <path d="M8 2l1.88 1.88" />
              <path d="M14.12 3.88L16 2" />
              <path d="M9 7.13v-1a3.003 3.003 0 116 0v1" />
              <path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 014-4h4a4 4 0 014 4v3c0 3.3-2.7 6-6 6" />
              <path d="M12 20v-9" />
              <path d="M6.53 9C4.6 8.8 3 7.1 3 5" />
              <path d="M6 13H2" />
              <path d="M3 21c0-2.1 1.7-3.9 3.8-4" />
              <path d="M20.97 5c0 2.1-1.6 3.8-3.5 4" />
              <path d="M22 13h-4" />
              <path d="M17.2 17c2.1.1 3.8 1.9 3.8 4" />
            </svg>
          </div>
          <div>
            <div class="feedback-panel__title">Reportar</div>
            <div class="feedback-panel__subtitle">
              Conte o que está quebrado ou o que poderia melhorar
            </div>
          </div>
        </div>
        <button type="button" class="feedback-panel__close-btn" (click)="onClose()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="feedback-panel__body">
        <form [formGroup]="form">
          <div class="feedback-panel__section">
            <label class="feedback-panel__label">
              Tipo <span class="feedback-panel__required">*</span>
            </label>
            <div class="feedback-panel__type-grid">
              <button
                type="button"
                class="feedback-panel__type-card"
                [class.feedback-panel__type-card--selected-bug]="selectedType === 'Bug'"
                (click)="selectType('Bug')">
                <svg
                  class="feedback-panel__type-icon feedback-panel__type-icon--bug"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  width="20"
                  height="20">
                  <path d="M8 2l1.88 1.88" />
                  <path d="M14.12 3.88L16 2" />
                  <path d="M9 7.13v-1a3.003 3.003 0 116 0v1" />
                  <path
                    d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 014-4h4a4 4 0 014 4v3c0 3.3-2.7 6-6 6" />
                  <path d="M12 20v-9" />
                  <path d="M6.53 9C4.6 8.8 3 7.1 3 5" />
                  <path d="M6 13H2" />
                  <path d="M3 21c0-2.1 1.7-3.9 3.8-4" />
                  <path d="M20.97 5c0 2.1-1.6 3.8-3.5 4" />
                  <path d="M22 13h-4" />
                  <path d="M17.2 17c2.1.1 3.8 1.9 3.8 4" />
                </svg>
                <div>
                  <div class="feedback-panel__type-name">Bug</div>
                  <div class="feedback-panel__type-desc">Algo não funciona como esperado</div>
                </div>
              </button>
              <button
                type="button"
                class="feedback-panel__type-card"
                [class.feedback-panel__type-card--selected-suggestion]="
                  selectedType === 'Suggestion'
                "
                (click)="selectType('Suggestion')">
                <i
                  class="pi pi-lightbulb feedback-panel__type-icon feedback-panel__type-icon--suggestion"></i>
                <div>
                  <div class="feedback-panel__type-name">Sugestão</div>
                  <div class="feedback-panel__type-desc">Ideia de melhoria ou nova feature</div>
                </div>
              </button>
            </div>
          </div>

          <div class="feedback-panel__section">
            <div class="feedback-panel__label-row">
              <label class="feedback-panel__label">Anexos</label>
              <span class="feedback-panel__optional">opcional</span>
            </div>

            <div class="feedback-panel__attachments-grid">
              <div
                role="group"
                class="feedback-panel__attachment-card feedback-panel__attachment-card--screenshot"
                [class.feedback-panel__attachment-card--active]="
                  screenshotConfirmed || screenshotBlob()
                "
                [class.feedback-panel__attachment-card--loading]="isCapturingScreenshot()">
                <div
                  role="button"
                  class="feedback-panel__attachment-card-main"
                  [attr.tabindex]="isCapturingScreenshot() ? -1 : 0"
                  [attr.aria-disabled]="isCapturingScreenshot()"
                  [attr.aria-busy]="isCapturingScreenshot()"
                  [attr.aria-label]="
                    isCapturingScreenshot()
                      ? 'Capturando tela'
                      : !screenshotBlob() && !screenshotConfirmed
                        ? 'Capture a tela atual'
                        : 'Editar print da tela'
                  "
                  (click)="onScreenshotCardMainClick()"
                  (keydown)="onScreenshotCardMainKeydown($event)">
                  @if (isCapturingScreenshot()) {
                    <i class="pi pi-spin pi-spinner"></i>
                  } @else {
                    <i class="pi pi-image"></i>
                  }
                  <div>
                    <div class="feedback-panel__attachment-name">
                      @if (isCapturingScreenshot()) {
                        Capturando...
                      } @else if (screenshotConfirmed) {
                        Print editado
                      } @else if (screenshotBlob()) {
                        Editar print da tela
                      } @else {
                        Capture a tela atual
                      }
                    </div>
                    <div class="feedback-panel__attachment-desc">
                      Capture e desenhe sobre a tela atual
                    </div>
                  </div>
                </div>
                @if (screenshotBlob() || screenshotConfirmed) {
                  <button
                    type="button"
                    class="feedback-panel__attachment-refresh"
                    aria-label="Capturar tela novamente"
                    [disabled]="isCapturingScreenshot()"
                    (click)="onRecaptureScreenshotClick($event)">
                    <i class="pi pi-refresh"></i>
                  </button>
                }
              </div>

              <div
                role="group"
                class="feedback-panel__attachment-card"
                [class.feedback-panel__attachment-card--recording]="isRecording"
                [class.feedback-panel__attachment-card--selecting]="showMicSelection"
                [class.feedback-panel__attachment-card--active]="
                  recordingFile && !isRecording && !isSavingRecording
                "
                [class.feedback-panel__attachment-card--has-action]="
                  recordingFile && !isRecording && !isSavingRecording
                ">
                <button
                  type="button"
                  class="feedback-panel__recording-btn"
                  [disabled]="isSavingRecording"
                  (click)="onRecordingCardClick()">
                  @if (isSavingRecording) {
                    <i class="pi pi-spin pi-spinner"></i>
                  } @else if (showMicSelection) {
                    <i class="pi pi-times"></i>
                  } @else {
                    <i
                      class="pi pi-circle-fill"
                      [class.feedback-panel__recording-dot]="isRecording"></i>
                  }
                  <div>
                    <div class="feedback-panel__attachment-name">
                      @if (isRecording) {
                        Parar gravação
                      } @else if (isSavingRecording) {
                        Salvando gravação...
                      } @else if (showMicSelection) {
                        Cancelar
                      } @else if (recordingFile) {
                        Ver gravação
                      } @else {
                        Gravar tela
                      }
                    </div>
                    <div class="feedback-panel__attachment-desc">
                      @if (isRecording && hasMicAudio) {
                        <i class="pi pi-microphone"></i> Microfone ativo
                      } @else if (showMicSelection) {
                        Clique para cancelar
                      } @else {
                        Capture um vídeo curto reproduzindo o problema
                      }
                    </div>
                  </div>
                </button>
                @if (recordingFile && !isRecording && !isSavingRecording) {
                  <button
                    type="button"
                    class="feedback-panel__attachment-refresh"
                    aria-label="Remover gravação"
                    (click)="removeRecording()">
                    <i class="pi pi-trash"></i>
                  </button>
                }
              </div>
            </div>

            @if (showMicSelection) {
              <div class="feedback-panel__mic-picker">
                <div class="feedback-panel__mic-picker-header">
                  <span class="feedback-panel__mic-picker-title">
                    <i class="pi pi-microphone"></i>
                    Microfone para gravação
                  </span>
                </div>
                <button
                  type="button"
                  class="feedback-panel__mic-option feedback-panel__mic-option--mute"
                  (click)="startRecordingWithMic(null)">
                  <i class="pi pi-volume-off"></i>
                  <div>
                    <div class="feedback-panel__mic-option-name">Sem áudio</div>
                  </div>
                </button>
                <button
                  type="button"
                  class="feedback-panel__mic-option"
                  (click)="startRecordingWithMic('')">
                  <i class="pi pi-microphone"></i>
                  <div>
                    <div class="feedback-panel__mic-option-name">Padrão do sistema</div>
                  </div>
                </button>
                @for (device of micDevices; track device.deviceId; let i = $index) {
                  <button
                    type="button"
                    class="feedback-panel__mic-option"
                    (click)="startRecordingWithMic(device.deviceId)">
                    <i class="pi pi-microphone"></i>
                    <div>
                      <div class="feedback-panel__mic-option-name">
                        {{ device.label || 'Microfone ' + (i + 1) }}
                      </div>
                    </div>
                  </button>
                }
              </div>
            }

            @if (showVideoPlayer && recordingPreviewUrl) {
              <app-feedback-video-player
                [videoUrl]="recordingPreviewUrl"
                filename="gravacao-tela.webm"
                (closed)="onVideoPlayerClosed()"
                (deleted)="removeRecording()" />
            }

            <div class="feedback-panel__other-attachments">
              <div class="feedback-panel__other-row">
                <i class="pi pi-paperclip"></i>
                <span class="feedback-panel__other-label">Outros</span>
                <span class="feedback-panel__other-hint"
                  >Anexar arquivos do computador (imagens, vídeos, PDFs...)</span
                >
                <label class="feedback-panel__file-btn">
                  <i class="pi pi-plus"></i>
                  <input type="file" multiple hidden (change)="onFileSelected($event)" />
                </label>
              </div>
              @if (otherAttachments.length > 0) {
                <ul class="feedback-panel__file-list">
                  @for (att of otherAttachments; track att.name; let i = $index) {
                    <li class="feedback-panel__file-item">
                      <i class="pi pi-file"></i>
                      <span class="feedback-panel__file-name">{{ att.name }}</span>
                      <span class="feedback-panel__file-size">{{ att.size }}</span>
                      <button
                        type="button"
                        class="feedback-panel__file-remove"
                        (click)="removeAttachment(i)">
                        <i class="pi pi-times"></i>
                      </button>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>

          <div class="feedback-panel__section">
            <div class="feedback-panel__label-row">
              <label class="feedback-panel__label">
                Descrição <span class="feedback-panel__required">*</span>
              </label>
              <span class="feedback-panel__char-count">{{ descriptionLength }} / 1000</span>
            </div>
            <textarea
              class="feedback-panel__textarea"
              formControlName="description"
              maxlength="1000"
              rows="5"
              placeholder="O que aconteceu? O que você esperava que acontecesse? Inclua passos para reproduzir, se possível."></textarea>
            <div class="feedback-panel__textarea-footer">
              <span>Markdown básico suportado</span>
              <span>Shift + Enter para quebrar linha</span>
            </div>
          </div>

          <div class="feedback-panel__auto-info">
            <i class="pi pi-info-circle"></i>
            <span>
              Anexamos automaticamente:
              <code>rota</code>, <code>build</code>, <code>userAgent</code>, <code>logs</code>.
            </span>
          </div>
        </form>
      </div>

      <div class="feedback-panel__footer">
        @if (hasContent) {
          <button type="button" class="feedback-panel__btn-reset" (click)="clearAll()">
            <i class="pi pi-trash"></i>
            Limpar tudo
          </button>
        }
        <div class="feedback-panel__footer-actions">
          <button type="button" class="feedback-panel__btn-cancel" (click)="onClose()">
            Fechar
          </button>
          <button
            type="button"
            class="feedback-panel__btn-submit"
            [disabled]="!isFormValid || isSubmitting"
            (click)="submit()">
            @if (isSubmitting) {
              <i class="pi pi-spin pi-spinner"></i>
            } @else {
              <i class="pi pi-send"></i>
            }
            Enviar feedback
          </button>
        </div>
      </div>
    }
  </div>
</div>
